import { IStepByStep, IStepProps } from './types'
import './styles.scss'
import { Check } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useSteps } from '../../hooks/setup/useSteps'
import {
  KEY_PATH_SETUP_USER,
  KEY_SETUP_SYSTEM,
  KEY_SETUP_SYSTEM_CONFIG,
  KEYS_ROUTES,
} from '../../utils/constants'
import { useNavigate } from 'react-router-dom'
import { useStepContext } from '../../hooks/setup/useStepContext'
import { Loader } from '../loader'

export const StepByStep = ({ steps }: IStepByStep) => {
  const { steps: getSteps, getCurrentStepActive } = useSteps()
  const { currentActive } = useStepContext()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  const [listSteps, setListSteps] = useState<IStepProps[]>(
    steps?.length ? steps : []
  )
  const [distances, setDistances] = useState<number[]>([])
  const pointsRef = useRef<HTMLSpanElement[]>([])

  useEffect(() => {
    if (steps?.length) return

    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentActive])

  useEffect(() => {
    window.addEventListener('resize', updateDistances)

    return () => {
      window.removeEventListener('resize', updateDistances)
    }
  }, [])

  useEffect(() => {
    updateDistances()
  }, [listSteps])

  const getCurrentRoute = (currentStep: IStepProps | null | undefined) => {
    if (!currentStep) return KEY_PATH_SETUP_USER

    if (currentStep.id === KEY_SETUP_SYSTEM_CONFIG) return KEY_SETUP_SYSTEM

    return currentStep.id
  }

  const load = async () => {
    const [stepsList, currentStepActive] = await Promise.all([
      getSteps(),
      getCurrentStepActive(),
    ])

    const route = KEYS_ROUTES[getCurrentRoute(currentStepActive)]
    if (route) navigate(route)

    setLoading(false)
    setListSteps(stepsList.filter((step) => !step.parent))
  }

  const updateDistances = () => {
    if (!pointsRef.current) return

    const newDistances = []
    for (let i = 0; i < pointsRef.current.length - 1; i++) {
      const currentPoint = pointsRef.current[i]?.getBoundingClientRect()
      const nextPoint = pointsRef.current[i + 1]?.getBoundingClientRect()
      const distance = nextPoint.left - currentPoint.left
      newDistances.push(distance)
    }
    setDistances(newDistances)
  }

  if (loading) {
    return (
      <div className="container-load">
        <Loader size={30} />
      </div>
    )
  }

  return (
    <div className="containerMainSteps">
      {listSteps.map((step, index) => (
        <div
          key={index}
          className={`step ${step.active || step.completed ? 'stepActive' : ''}`}
        >
          <div className="contentStepper">
            <span
              className={`${step.active || step.completed ? 'stepActive' : ''}`}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ref={(el) => ((pointsRef.current[index] as any) = el)}
            >
              {step.completed ? <Check size={16} color="#fff" /> : step.id}
            </span>

            {index < listSteps.length - 1 && (
              <div
                className="line"
                style={{
                  background: step.completed ? '#9F00EA' : 'transparent',
                  borderTop: `1px ${step.completed ? 'solid' : 'dashed'} #9F00EA`,
                  width: distances[index] || 0,
                  left: '50%',
                  transform: 'translateX(0)',
                }}
              ></div>
            )}
          </div>
          <p className={`${step.active || step.completed ? 'stepActive' : ''}`}>
            {step.title}
          </p>
        </div>
      ))}
    </div>
  )
}
